import { render, staticRenderFns } from "./gateway-account-details.vue?vue&type=template&id=1daf35e5&"
import script from "./gateway-account-details.vue?vue&type=script&lang=js&"
export * from "./gateway-account-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports